import { useState } from "react";
import CustomTable from "../Components/CustomTable";
import "../Styling/EmployeeList.css";

const EmployeeList = () => {
  const [employees] = useState([
    {
      employeeCode: "E-1001",
      name: "John",
      rank: "Captain",
      category: "Permanent",
      status: "Active",
    },
    {
      employeeCode: "E-1002",
      name: "Mary",
      rank: "Engineer",
      category: "Intern",
      status: "Active",
    },
    {
      employeeCode: "E-1003",
      name: "Robert",
      rank: "Officer",
      category: "Contract",
      status: "Active",
    },
  ]);
//   const [filteredEmployees, setFilteredEmployees] = useState([]);
//   const [selectedId, setSelectedId] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [selectedCategories, setSelectedCategories] = useState([]);
   const [selectedId, setSelectedId] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const columns = [
    { header: "Employee ID", accessor: "employeeCode" },
    { header: "Name", accessor: "name" },
    { header: "Rank", accessor: "rank" },
    { header: "Category", accessor: "category" },
    {
      header: "Status",
      render: (row) => (
        <span className="status-pill">
          {row.status}
        </span>
      ),
    },
  ];

console.log("selectedCategory", selectedCategory);
// const filteredData = employees.filter((emp) => {
//     const idMatch =
//       !selectedId ||
//       selectedId === "Search by ID" ||
//       emp.employeeCode === selectedId;

//     const categoryMatch =
//       !selectedCategory ||
//       selectedCategory === "Filter by Category" ||
//       emp.category === selectedCategory;

//     return idMatch && categoryMatch;
//   });
const filteredData = employees.filter((emp) => {
  const idMatch = selectedId ? emp.employeeCode === selectedId : true;
  const categoryMatch = selectedCategory
    ? emp.category === selectedCategory
    : true;

  return idMatch && categoryMatch;
});
  return (
    <div className="page-container">
      <div className="header-section">
        <h1>Onroll / Employee List</h1>

        <div className="filters">
          <select style={{height:"40px"}} className="dropdown" value={selectedId}   onChange={(e) => setSelectedId(e.target.value)}>
            <option value="">Search by ID</option>
            <option value="E-1001">E-1001</option>
            <option value="E-1002">E-1002</option>
            <option value="E-1003">E-1003</option>
          </select>

          <select style={{height:"40px"}} className="dropdown" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
            <option value="">Filter by Category</option>
            <option>Permanent</option>
            <option>Intern</option>
            <option>Contract</option>
          </select>
        </div>
      </div>

      <CustomTable columns={columns} data={filteredData} />
    </div>
  );
};

export default EmployeeList;